export default class Dashboard {

	constructor() {
		this.instance = self;
	}

	static init() {
		const self = new Dashboard;

		self.attachEvents();
	}

	attachEvents() {
		const self = this;

        $(document).on('click', '.sidebar-dropdown > a', function(e) {
            e.preventDefault();
			self.toggleSubMenu($(this));
		});
	}

	toggleSubMenu($el) {
		const self = this;

        $('.sidebar-submenu').slideUp(200);

        if ($el.parent().hasClass('active')) {
          $('.sidebar-dropdown').removeClass('active');

          $el.parent().removeClass('active');
        } else {
          $('.sidebar-dropdown').removeClass('active');

          $el.next('.sidebar-submenu').slideDown(200);
          $el.parent().addClass('active');
        }
	}
}


